import React, { useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import { toastEmitter, ToastSeverity } from "utils/toast.util";

export const ToastContainer = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<ToastSeverity>("error");

  useEffect(() => {
    toastEmitter.subscribe((msg, sev) => {
      setMessage(msg);
      setSeverity(sev);
      setOpen(true);
    });
    return () => toastEmitter.unsubscribe();
  }, []);

  const handleClose = () => setOpen(false);

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
